/* 문화포럼 일정 등록 페이지 */import Box          from '@mui/material/Box';
import React, {useEffect, useRef, useState}             from 'react';
import {constance}                                      from '../../common/constance/constance';
import Stack                                            from '@mui/material/Stack';
import {config}                                         from '../../common/config/config';
import Typography                                       from '@mui/material/Typography';
import TextField                                        from '@mui/material/TextField';
import axios                                            from 'axios';
import {styles}                                         from '../../common/style';
import {Button, MenuItem, MenuList, Paper} from '@mui/material';
import {common}                                         from '../../common/common';
import ImageUploading                                   from 'react-images-uploading';
import {useNavigate}                                    from 'react-router-dom';
import {User}                                           from '../../interface/user.interface';

interface State {
	number: number;         // 회차
	title: string;          // 제목
	time: number;             // 발표일
	presenterId: string;    // 발표자
	fileName: string;       // 발표자료
	thumbnail: any;       // 썸네일
	presenterName: string,
	userListOpen: boolean,
	userList: User[],
	fileList: File[];
}

function CultureForumRegister() {
	const [state, setState] = useState<State>({
		fileName: '',
		number: 0,
		presenterId: '',
		thumbnail: '',
		title: '',
		time: 0,
		presenterName: '',
		userListOpen: false,
		userList: [],
		fileList: [],
	});
	const [images, setImages] = useState([]);
	
	const numberRef: any = useRef();
	const titleRef: any = useRef();
	const timeRef: any = useRef();
	const fileInputRef: any = useRef();
	const navigate = useNavigate();
	
	useEffect(() => {
		/* 사용자 리스트 가지고 오기 */
		axios.get(constance.api.getUserList).then((value) => {
			if (value.data.data) {
				for (let user of value.data.data) {
					user.name = user.name.trim();
					user.id = user.id.trim();
					user.departmentName = user.departmentName !== null ? user.departmentName.trim() : '';
					user.departmentCode = user.departmentCode.trim();
				}
				setState({
					...state,
					userList: value.data.data,
				});
			}
		}).catch(reason => {
			alert(reason);
		});
	}, []);
	
	const handleChange = (e: any, key: string) => {
		let value = e.target.value;
		setState({
			...state,
			[key]: value,
		});
	};
	
	function handleChangePresenter(e: any, user: User) {
		let value = e.currentTarget.value;
		setState({
			...state,
			userListOpen: false,
			presenterId: value,
			presenterName: `${user.departmentName} ${user.name}`,
		});
	}
	
	function handleOpenList() {
		setState({
			...state,
			presenterName: '',
			userListOpen: true,
		});
	}
	
	function handleSave() {
		if (state.presenterId == '') {
			common.alert('발표자 입력 오류', '발표자는 리스트에서 클릭하여 입력 가능합니다.', 'info');
			return;
		}

		const number = numberRef.current.value;
		const title = titleRef.current.value;
		const time = timeRef.current.value;
		
		const formData = new FormData();
		let image: any = images[0];
		if (image == null) {
			common.alert('', '문화포럼 썸네일 이미지를 등록해주세요.', 'info');
			return;
		}
		let file = image.file;
		let files = [];
		files.push(file);
		if (state.fileList.length == 0) {
			common.alert('', '문화포럼 발표자료를 등록해주세요.', 'info');
			return;
		}
		let array: any = files.concat(state.fileList);
		for (let file of array) {
			formData.append('files', file);
		}
		
		formData.append('values', JSON.stringify({
			number: number,
			title: title,
			time: time,
			presenterId: state.presenterId,
		}));
		
		axios({
			method: 'post',
			url: constance.api.createCultureForum,
			data: formData,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}).then(value => {
			console.log(value);
			if (value.data.success) {
				common.alert('', '등록 성공', 'info');
				// /cultureForum/replay
				navigate(config.menu[0].subMenu[1].path);
			} else {
				common.alert('', '등록 실패', 'info');
			}
		}).catch(reason => {
			console.log(reason);
		});
	}
	
	function openFile(e: any) {
		e.preventDefault();

		if (state.fileList.length == 1) {
			common.alert('자료 등록 오류', '자료는 1개만 등록 가능합니다.', 'info');
			return;
		}
		fileInputRef.current.click();
	}
	
	function handleFileChange(event: any) {
		// formData.append('files', event.target.files[0]);
		// let fileList = JSON.parse(JSON.stringify(files));
		let file: File = event.target.files[0];
		state.fileList.push(file);
		setState({
			...state,
			fileList: state.fileList,
		});
	}
	
	const onChange = (imageList: any, addUpdateIndex: any) => {
		console.log(imageList, addUpdateIndex);
		setImages(imageList);
	};
	
	function removeFile(index: number) {
		state.fileList.splice(index, 1);
		setState({
			...state,
			fileList: state.fileList,
		});
	}
	
	return (
			<>
				<Stack sx={{width: 1, alignItems: 'center', justifyContent: 'center'}}>
					<Stack sx={{
						width: 1,
						mt: 3,
						maxWidth: config.maxWidth,
						alignItems: 'center',
						border: styles.border,
					}}>
						
						{/* 회차 */}
						<Box sx={{
							display: 'flex',
							borderBottom: styles.border,
							width: 1,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'회차'}</Typography>
							</Box>
							<Box
									sx={{
										flexGrow: 1,
										backgroundColor: styles.backgroundColor.contentBox,
										p: 1,
									}}>
								<TextField inputRef={numberRef}
								           defaultValue={0}
								           type={'number'}
								           label="" variant="outlined"
								           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
								/>
							
							</Box>
						</Box>
						
						
						{/* 주제 */}
						<Box sx={{
							display: 'flex',
							borderBottom: styles.border,
							width: 1,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'주제'}</Typography>
							</Box>
							<Box
									sx={{
										flexGrow: 1,
										backgroundColor: styles.backgroundColor.contentBox,
										p: 1,
									}}>
								<TextField inputRef={titleRef}
								           placeholder="주제를 입력해주세요."
								           label="" variant="outlined"
								           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
								/>
							
							</Box>
						</Box>
						
						{/* 발표일 */}
						<Box sx={{
							display: 'flex',
							width: 1,
							borderBottom: styles.border,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'발표일'}</Typography>
							</Box>
							<Box sx={{
								flexGrow: 1,
								backgroundColor: styles.backgroundColor.contentBox,
								p: 1,
								
							}}>
								<TextField inputRef={timeRef}
								           label="문화포럼 시간"
								           type="datetime-local"
								           value={state.time}
								           onChange={(e) => handleChange(e, 'time')}
								           sx={{width: 250, backgroundColor: 'var(--scc-surface)'}}
								           InputLabelProps={{
									           shrink: true,
								           }}
								/>
							</Box>
						</Box>
						
						
						{/* 발표자 */}
						<Box sx={{
							display: 'flex',
							width: 1,
							borderBottom: styles.border,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'발표자'}</Typography>
							</Box>
							<Box sx={{
								flexGrow: 1,
								backgroundColor: styles.backgroundColor.contentBox,
								p: 1,
								position: 'relative',
							}}>
								<TextField placeholder="발표자 이름을 입력해주세요."
								           value={state.presenterName}
								           onClick={handleOpenList}
								           onChange={(e) => handleChange(e, 'presenterName')}
								           label="" variant="outlined"
								           sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
								/>
								<Paper sx={{
									width: 320, maxWidth: '100%',
									position: 'absolute',
									maxHeight: '400px',
									overflowY: 'auto',
									zIndex: 10,
									display: state.userListOpen ? 'flex' : 'none',
								}}>
									<MenuList>
										{
											state.userList.map((user, index) => {
												if (common.isEmpty(user.departmentName)) return;
												if (user.name == '이남주' && user.departmentName == '디자인팀') return;
												if (state.presenterName !== '') {
													if (user.name.indexOf(state.presenterName) == -1 && user.departmentName.indexOf(state.presenterName) ==
															-1) {
														return;
													}
												}
												return (
														<MenuItem value={user.id}
														          key={index}
														          onClick={(e) => handleChangePresenter(e, user)}>
															<Typography>
																{`${user.departmentName} ${user.name}`}
															</Typography>
														</MenuItem>
												);
											})
										}
									
									</MenuList>
								</Paper>
							</Box>
						</Box>
						
						
						{/* 썸네일 */}
						<Box sx={{
							display: 'flex',
							borderBottom: styles.border,
							width: 1,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'썸네일'}</Typography>
							</Box>
							<Box sx={{
								display: 'flex',
								justifyContent: 'flex-start',
								flexGrow: 1,
								backgroundColor: styles.backgroundColor.contentBox,
								p: 1,
							}}>
								<ImageUploading
										multiple
										value={images}
										onChange={onChange}
										maxNumber={1}
										dataURLKey="data_url"
										// onError={onError}
								>
									{({
										  imageList,
										  onImageUpload,
										  onImageRemoveAll,
										  onImageUpdate,
										  onImageRemove,
										  isDragging,
										  dragProps,
									  }) => (
											// write your building UI
											<Stack className="upload__image-wrapper" sx={{display: 'flex', width: 300}}>
												<Button variant={'contained'}
												        style={isDragging ? {color: 'red'} : undefined}
												        onClick={onImageUpload}
												        {...dragProps}
												>
													사진추가
												</Button>
												{/* <button onClick={onImageRemoveAll}>Remove all images</button> */}
												{imageList.map((image, index) => (
														<Box key={index} className="image-item" sx={{display: 'flex', mt: 2}}>
															<Box sx={{width: 0.8, border: styles.border, mb: 1}}>
																<img src={image['data_url']} alt="" style={{width: '100%'}}/>
															</Box>
															
															<Stack className="image-item__btn-wrapper" sx={{display: 'flex', ml: 2, justifyContent: 'center'}}>
																<Button variant={'outlined'}
																        color={'info'}
																        onClick={() => onImageUpdate(index)}>수정</Button>
																<Button variant={'outlined'}
																        color={'error'}
																        sx={{mt: 2}}
																        onClick={() => onImageRemove(index)}>삭제</Button>
															</Stack>
														</Box>
												))}
											</Stack>
									)}
								</ImageUploading>
							</Box>
						</Box>
						
						{/* 썸네일 */}
						<Box sx={{
							display: 'flex',
							borderBottom: styles.border,
							width: 1,
						}}>
							<Box sx={{
								display: 'flex',
								backgroundColor: styles.backgroundColor.titleBox,
								p: 1,
								pl: 2,
								alignItems: 'center',
								justifyContent: 'center',
							}}>
								<Typography variant={'h6'} sx={{width: 150}}> {'발표자료'}</Typography>
							</Box>
							<Stack sx={{
								display: 'flex',
								justifyContent: 'flex-start',
								flexGrow: 1,
								backgroundColor: styles.backgroundColor.contentBox,
								p: 1,
							}}>
								<Button variant={'contained'}
								        onClick={openFile}
								        sx={{width: 200}}
								>
									파일추가
								</Button>
								<input ref={fileInputRef}
								       type={'file'}
								       onChange={handleFileChange}
								       style={{display: 'none'}}/>
								<Stack sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'center', width: 1}}>
									{
										state.fileList.map((value, index) => {
											return (
													<Box key={index}
													     sx={{display: 'flex', alignItems: 'center', width: 300}}>
														<Box sx={{width: 0.8}}>
															<Typography>{value['name']}</Typography>
														</Box>
														<Button variant={'outlined'}
														        color={'error'}
														        size={'small'}
														        onClick={(e) => removeFile(index)}
														        sx={{mt: 1, ml: 2}}><Typography>삭제</Typography></Button>
													</Box>
											);
										})
									}
								</Stack>
							</Stack>
						</Box>
					</Stack>
					
					<Box sx={{mt: 2}}>
						<Button onClick={handleSave}
						        variant={'contained'}>
							<Typography> {'등록'}</Typography>
						</Button>
					</Box>
				</Stack>
			</>
	);
};

export default CultureForumRegister;